import axios from 'axios'

export default class Form {
    constructor (fields) {
        this.fields = fields
        this.errors = []
    }

    validationRules (rules) {
        const keys = Object.keys(rules)

        for (let key of keys) {
            let isExists = this._checkField(key)

            if (!isExists) {
                return new Error(`Field '${key}' is not exists.`)
            }

            let rule = rules[key]
            let reqRules = this._splitRule(rule)

            for (let reqRule of reqRules) {
                let rule = this._splitReqRule(reqRule)

                if (rule.length === 1) {
                    let currentRule = rule[0]
                    switch (currentRule) {
                    case 'required':
                        if (!this._isRequired(this.fields[key])) {
                            let error = { key, message: `Полето е задължително.` }
                            this.errors.push(error)
                        }
                        break
                    }
                }
            }
        }
    }

    send (path, contact) {
        let formData = new FormData(contact)
        return axios.post(path, formData)
    }

    validate () {
        console.log('validate')
    }

    _checkField (field) {
        return Object.keys(this.fields).filter(f => f === field)[0]
    }

    _splitRule (rule) {
        if (rule.indexOf('|')) return rule.split('|')
        return rule
    }

    _splitReqRule (reqRule) {
        if (reqRule.indexOf(':')) return reqRule.split(':')
        return reqRule
    }

    _isRequired (value) {
        return value && value.length >= 1
    }
}



// WEBPACK FOOTER //
// ./src/services/form.js